import { render, staticRenderFns } from "./RunningList.vue?vue&type=template&id=37ec33d8"
import script from "./RunningList.vue?vue&type=script&lang=js"
export * from "./RunningList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37ec33d8')) {
      api.createRecord('37ec33d8', component.options)
    } else {
      api.reload('37ec33d8', component.options)
    }
    module.hot.accept("./RunningList.vue?vue&type=template&id=37ec33d8", function () {
      api.rerender('37ec33d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/flowable/process/RunningList.vue"
export default component.exports